import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  firstName: {
    width: '16%',
  },
  lastName: {
    width: '16%',
  },
  emailAddress: {
    width: '20%',
  },
  phoneNumber: {
    width: '15%',
  },
  createDate: {
    width: '10%',
  },
  lastLoginDate: {
    width: '10%',
  },
  actions: {
    width: '13%',
  },
}));

export default useStyles;
